import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import ScrollTrigger from "gsap/ScrollTrigger";
import { useEffect, useRef } from "react";
import AnimatedLine from "../../components/AnimatedLine/AnimatedLine";



const HomeAbout = () => {

   gsap.registerPlugin(useGSAP);
   gsap.registerPlugin(ScrollTrigger);



   useGSAP(() => {

      // ***********secTwo*********
      ScrollTrigger.matchMedia({
         "(min-width: 768px)": function () {

            gsap.fromTo(".AiCrtScrBx", {
               scale: 0.8,
               opacity: 0
            }, {
               scale: 1,
               opacity: 1,
               duration: 1,
               ease: "power2.out",
               scrollTrigger: {
                  trigger: ".IndSecTwo",
                  start: "top center",
                  toggleActions: "play none none reverse"
               }
            });


            gsap.fromTo(".ManAiImg3", {
               opacity: 0,
            }, {
               opacity: 1,
               scrollTrigger: {
                  trigger: ".IndSecTwo",
                  start: "top 0%",
                  end: "bottom -10%",
                  //markers: true,
                  toggleActions: "play none none reverse"
               }
            });

            gsap.fromTo(".ManAiImg2", {
               opacity: 0,
            }, {
               opacity: 1,
               scrollTrigger: {
                  trigger: ".IndSecTwo",
                  start: "top -10%",
                  end: "bottom -20%",
                  //markers: true,
                  toggleActions: "play none none reverse"
               }
            });


            // function animation_text_1(element) {
            //    let newText = "";
            //    let theText = document.querySelector(element);
            //    for (let i = 0; i < theText.innerText.length; i++) {
            //       newText += "<span class='d-inline-block'>";
            //       if (theText.innerText[i] == " ") { newText += "&nbsp;" }
            //       else { newText += theText.innerText[i]; }
            //       newText += "</span>";
            //    }
            //    theText.innerHTML = newText;
            //    gsap.fromTo(element + " span", {
            //       opacity: 0,
            //       y: 90,
            //       filter: 'blur(10px)',
            //    }, {
            //       duration: 2,
            //       opacity: 1,
            //       y: 0,
            //       filter: 'blur(0px)',
            //       stagger: 0.03,
            //       ease: "elastic(1.2, 0.5)",
            //       scrollTrigger: {
            //          trigger: element,
            //          start: "top 50%", // start when the top of the <h1> reaches 70% down from the top of the viewport
            //          toggleActions: "restart none none reverse",
            //          //markers: true
            //       }
            //    });
            // }
            // animation_text_1(".AiCntSrcTx1");
            // animation_text_1(".AiCntSrcTx2");


            // gsap.fromTo(".AiCntSrc p", {
            //    opacity: 0,
            //    y: 20,
            //    filter: 'blur(10px)',
            // }, {
            //    opacity: 1,
            //    y: 0,
            //    filter: 'blur(0px)',
            //    scrollTrigger: {
            //       trigger: ".AiCntSrc p",
            //       start: "top 50%",
            //       //markers: true,
            //       toggleActions: "play none none reverse"
            //    }
            // });
         }
      })


      // gsap.fromTo(
      //    ".line-child",
      //    { opacity: 0, filter: "blur(10px)", y: 20 },
      //    {
      //       opacity: 1,
      //       filter: "blur(0px)",
      //       y: 0,
      //       duration: 1,
      //       stagger: 0.2,
      //       ease: "power2.out",
      //       scrollTrigger: {
      //          trigger: paraRef.current,
      //          start: "top 50%",
      //          toggleActions: "play none none reverse",
      //          markers: true,
      //       },
      //    }
      // );


   }, {}); // <-- easily add a scope for selector text (optional)


   useEffect(() => {
      setInterval(() => {
         ScrollTrigger.refresh()
      }, [1500])
   }, [])


   return (
      <section className="IndSecTwo" id="about">
         <div className="container container-cus1190">
            <div className="AiCrtScrBx">
               <div className="row align-items-center">
                  <div className="col-xl-6">
                     <div className="ManAiImg">
                        <img className="img-fluid dark-img ManAiImg1" src={require("../../../assets/pics/about/about-1.png")} alt="about-1" />
                        <img className="img-fluid dark-img ManAiImg2" src={require("../../../assets/pics/about/about-2.png")} alt="about-1" />
                        <img className="img-fluid dark-img ManAiImg3" src={require("../../../assets/pics/about/about-3.png")} alt="about-1" />
                     </div>
                  </div>
                  <div className="col-xl-6">
                     <div className="AiCntSrc">
                        <h2><span className="AiCntSrcTx1">About </span> <span className="AiCntSrcTx2 noHl">Routine Coin</span></h2>
                        {/* <p ref={paraRef}>
                           Routine Coin (ROU) Embraces Polygon Blockchain Technology for Enhanced Security,
                           Scalability, and Interoperability* Routine Coin (ROU) is proud to announce its
                           integration with Polygon’s cutting-edge blockchain technology, a strategic move that
                           underscores our commitment to delivering superior security, scalability, and
                           interoperability for our community. By leveraging Polygon’s advanced blockchain
                           infrastructure, we are taking a significant step forward in fortifying the
                           foundation of Routine Coin.
                        </p> */}

                        <AnimatedLine para={`Routine Coin (ROU) Embraces Polygon Blockchain Technology for Enhanced Security,
                           Scalability, and Interoperability* Routine Coin (ROU) is proud to announce its
                           integration with Polygon’s cutting-edge blockchain technology, a strategic move that
                           underscores our commitment to delivering superior security, scalability, and
                           interoperability for our community. By leveraging Polygon’s advanced blockchain
                           infrastructure, we are taking a significant step forward in fortifying the
                           foundation of Routine Coin.`} />
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   )
}
export default HomeAbout;